// @core/api/endpoints/notifications/update_user_settings_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateUserSettingsEventRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update user event-specific notification settings
 * Updates notification preferences for specific event types. These settings override global preferences for the specified events.
 */
export async function UpdateUserSettingsEvent(
  user_id: string,
  data: UpdateUserSettingsEventRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/settings/events`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
